import { communityV2Store } from '~/store/communityV2'
export default defineNuxtRouteMiddleware(async (to, from) => {
  const cV2Store = communityV2Store()
  const countryId = useCookie(COUNTRY_COOKIE_KEY).value
  const locale = useLocale()
  await cV2Store.loadHomeContent({
    locale,
    countryId
  })
  await cV2Store.loadArticleCategories({
    locale: 'en',
    countryId
  })
  await cV2Store.loadArticleCategories({
    locale: 'es',
    countryId
  })
})
